import { AppName } from "types/app";
import { APP_NAME_KEYWORDS } from "constants/keywords";

const API_CONFIG: { [key in AppName]: string } = {
  "dermobella-skin": "3441/web-result/cndpskin",
  "dermobella-hair": "3331/web-result/cndphair",
  "dermopico-skin": "3771/web-result/cmaskin",
  "dermopico-hair": "3881/web-result/cmahair",
  "pierre-fabre-skin": "3441/web-result/cndpskin",
  "pierre-fabre-hair": "3331/web-result/cndphair",
  "morgan-hair": "3331/web-result/cndphair",
  "loreal-hair": "4002/web-result/lorealhair",
};

export const getApiUrls = () => {
  const { origin } = window.location;
  const isChinaDomain = origin.includes("china");

  const app = APP_NAME_KEYWORDS.find((name) => origin.includes(name));
  const type = origin.includes("hair") ? "hair" : "skin";
  let appName = `${app}-${type}` as AppName;
  // let appName = "loreal-hair" as AppName;

  const GET_RESULTS_URL = `https://${
    isChinaDomain ? "1.116.243.170" : "v2-api.chowis.cloud"
  }:${API_CONFIG[appName]}`;

  return { GET_RESULTS_URL, appName };
};
